import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-irs-max",
    prompt: "Would you like to automatically use the new IRS plan limit and rollover maximum for all of your plans? If you choose to use IRS limits, Ameriflex will automatically increase your plan limits for you if a new increase is announced.",
    briefDescription: "IRS Max",
    openAction: {
        text: "Where to see plan maximum?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Plan Limits"
    },
    actions: [
        { 
            text: "Yes, use IRS limits",
            recommended: true,
            click: async (component, guidanceItem) => {
                await romeApi.post(`employer/${guidanceItem.employerId}/order/${guidanceItem.orderId}/enable-irs-max`);
                await component.$store.dispatch("plans/load", {employerId: guidanceItem.employerId, refreshSameEmployer: true});
                await romeApi.post(`actionitem/v-2/${guidanceItem.actionItemId}/complete`);
            }
        },
        { 
            text: "No, I will set my own limits",
            click: async (component, guidanceItem) =>  {
                component.clickCompleteAction(guidanceItem);
            }
        }
    ]
});



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-irs-max.js